/* =============================================================================
   Lake Group — website behaviour
   =============================================================================
   Fills the auth brand panel with copy. The panel's background is painted by
   CSS, so this adds no layout shift — if it never runs, the page is still a
   correct, complete split-screen login.
   ========================================================================== */

(function () {
	"use strict";

	var AUTH_PATHS = ["login", "signup", "update-password"];

	function currentPath() {
		var body = document.body;
		return (body && body.getAttribute("data-path")) || "";
	}

	function buildPanel() {
		try {
			if (AUTH_PATHS.indexOf(currentPath()) === -1) return;
			if (document.querySelector(".lg-authpanel")) return;
			if (window.innerWidth < 900) return; // panel copy is hidden below this anyway

			var panel = document.createElement("div");
			panel.className = "lg-authpanel";
			panel.setAttribute("aria-hidden", "true"); // decorative; the form is the content
			panel.innerHTML = [
				'<div class="lg-authpanel-mark">',
				'  <img src="/assets/lghrmsdesign/images/lake-group-mark.png" alt="" width="44" height="44" style="border-radius:10px">',
				'  <span>Lake <em>Group</em></span>',
				"</div>",
				'<div class="lg-authpanel-lede">',
				"  <h1>One group. One record of every person in it.</h1>",
				"  <p>People, attendance, leave, payroll and statutory returns — across every company in the group, on a single employee record.</p>",
				'  <div class="lg-authpanel-stats">',
				"    <div><strong>People</strong><span>Record &amp; org</span></div>",
				"    <div><strong>Payroll</strong><span>Monthly run</span></div>",
				"    <div><strong>Statutory</strong><span>Tanzania</span></div>",
				"  </div>",
				"</div>",
				'<div class="lg-authpanel-foot">Lake Group &middot; Human Resources &amp; Payroll</div>',
			].join("\n");

			document.body.appendChild(panel);
		} catch (e) {
			/* decorative only */
		}
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", buildPanel);
	} else {
		buildPanel();
	}
})();
